// extracted by mini-css-extract-plugin
export default {"paginator":"Pagination_paginator__RlffD"};